import axios from 'axios';
import { API_BASE_URL } from '../../config/api';

export interface CrmOption {
  id: string;
  label: string;
}

export const crmApi = {
  getSegments: async (tenantId: string): Promise<CrmOption[]> => {
    const response = await axios.get(
      `${API_BASE_URL}/tenant/${tenantId}/crm/segments`,
      { params: crmQueryParams() },
    );
    return response.data;
  },

  /** `type` (e.g. SMTP) keeps only active channels of that type. */
  getChannels: async (tenantId: string, type?: string): Promise<CrmOption[]> => {
    const response = await axios.get(
      `${API_BASE_URL}/tenant/${tenantId}/crm/channels`,
      { params: { ...crmQueryParams(), ...(type ? { type } : {}) } },
    );
    return response.data;
  },

  /** Server-side lead search; without a query the CRM's default list. */
  getLeads: async (tenantId: string, query?: string): Promise<CrmOption[]> => {
    const response = await axios.get(
      `${API_BASE_URL}/tenant/${tenantId}/crm/leads`,
      { params: { ...crmQueryParams(), ...(query?.trim() ? { query: query.trim() } : {}) } },
    );
    return response.data;
  },
};

const crmQueryParams = (): Record<string, string> => {
  try {
    const params = new URLSearchParams(window.location.search);
    const crmTenantId = params.get('crmTenantId')?.trim();
    const crmJwtToken = params.get('crmJwtToken')?.trim();
    return {
      ...(crmTenantId ? { crmTenantId } : {}),
      ...(crmJwtToken ? { crmJwtToken } : {}),
    };
  } catch {
    return {};
  }
};
